var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame1171277032(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.800293,
    width: 38.5,
    height: 38,
    rx: 12,
    fill: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3379 10C24.4267 10 20.5204 12.0544 17.8971 15.5863H15.7225C14.1512 15.5863 13.2505 16.7926 12.6304 18.0684L11.8003 19.776H13.7601H15.7225L17.7592 21.8709L19.7958 23.9657V25.9842V28L21.456 27.1463C22.6963 26.5083 23.8692 25.582 23.8692 23.9657V21.729C27.303 19.0308 29.3003 15.0129 29.3003 12.0185V10H27.3379ZM23.8692 14.1897C24.6191 14.1897 25.227 14.815 25.227 15.5863C25.227 16.3576 24.6191 16.9829 23.8692 16.9829C23.1193 16.9829 22.5114 16.3576 22.5114 15.5863C22.5114 14.815 23.1193 14.1897 23.8692 14.1897ZM15.0436 22.5691L14.3647 23.2674C13.3841 24.276 13.007 26.7589 13.007 26.7589C13.007 26.7589 15.3125 26.4823 16.4014 25.3623L17.0803 24.664L15.0436 22.5691Z",
    fill: "url(#paint0_linear_3375_19270)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3379 10C24.4267 10 20.5204 12.0544 17.8971 15.5863H15.7225C14.1512 15.5863 13.2505 16.7926 12.6304 18.0684L11.8003 19.776H13.7601H15.7225L17.7592 21.8709L19.7958 23.9657V25.9842V28L21.456 27.1463C22.6963 26.5083 23.8692 25.582 23.8692 23.9657V21.729C27.303 19.0308 29.3003 15.0129 29.3003 12.0185V10H27.3379ZM23.8692 14.1897C24.6191 14.1897 25.227 14.815 25.227 15.5863C25.227 16.3576 24.6191 16.9829 23.8692 16.9829C23.1193 16.9829 22.5114 16.3576 22.5114 15.5863C22.5114 14.815 23.1193 14.1897 23.8692 14.1897ZM15.0436 22.5691L14.3647 23.2674C13.3841 24.276 13.007 26.7589 13.007 26.7589C13.007 26.7589 15.3125 26.4823 16.4014 25.3623L17.0803 24.664L15.0436 22.5691Z",
    fill: "url(#paint1_linear_3375_19270)",
    fillOpacity: 0.29
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7818 10C23.7874 10 19.7695 12.0544 17.0713 15.5863H14.8346C13.2183 15.5863 12.292 16.7926 11.6542 18.0684L10.8003 19.776H12.8161H14.8346L16.9294 21.8709L19.0243 23.9657V25.9842V28L20.7319 27.1463C22.0076 26.5083 23.214 25.582 23.214 23.9657V21.729C26.7459 19.0308 28.8003 15.0129 28.8003 12.0185V10H26.7818ZM23.214 14.1897C23.9853 14.1897 24.6106 14.815 24.6106 15.5863C24.6106 16.3576 23.9853 16.9829 23.214 16.9829C22.4427 16.9829 21.8174 16.3576 21.8174 15.5863C21.8174 14.815 22.4427 14.1897 23.214 14.1897ZM14.1363 22.5691L13.438 23.2674C12.4294 24.276 12.0414 26.7589 12.0414 26.7589C12.0414 26.7589 14.4128 26.4823 15.5329 25.3623L16.2311 24.664L14.1363 22.5691Z",
    fill: "url(#paint2_linear_3375_19270)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3375_19270",
    x1: 24.6088,
    y1: 4.3222,
    x2: 18.4335,
    y2: 27.6747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132927,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392361,
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7887,
    stopColor: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3375_19270",
    x1: 20.5503,
    y1: 9.91384,
    x2: 20.5503,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3375_19270",
    x1: 23.9748,
    y1: 4.43501,
    x2: 18.0032,
    y2: 27.7735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253989,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634371,
    stopColor: "#1C1C1C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1171277032);
export default __webpack_public_path__ + "static/media/Frame 1171277032.fe5103789f7c30ef86c56c2dfb513be9.svg";
export { ForwardRef as ReactComponent };